import { Pathology } from '@app/core/models/pathology';
import { createAction, props } from '@ngrx/store';
/**
 * Actions to patch the form values in smart reco store
 * from existing patient, lastConsultation or renal detect recommendation
 */
export const setSmartRecoFormValues = createAction('[Smart Reco] Set Form Values');

/**
 * Action to set pathologies
 */
export const setSmartRecoPathologies = createAction('[Smart Reco] Set Pathologies', props<{ value: Pathology[] }>());
